var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"22","height":"50","viewBox":"0 0 22 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0V47C0 47 12.3607 50 22 50V1.5C12.4142 1.5 0 0 0 0Z","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }